import Vue from 'vue'
import App from './App.vue'
import i18n from './plugins/i18n'
import Icon from 'vue-awesome/components/Icon'
import mixin from './plugins/mixin'
import router from './plugins/router.js'
import dotenv from 'dotenv'
import Config from './plugins/modules/config.js'
import keycloak from './plugins/keycloak.js'
import dotenvExpand from 'dotenv-expand'
import clickoutside from './plugins/clickoutside'

dotenvExpand(dotenv.config())

// the config must be instantiated before anything needing the backend will work
const config = new Config(function() {
    Vue.prototype.$config = config.current()

    Vue.config.productionTip = false
    Vue.component('v-icon', Icon)
    Vue.mixin(mixin)

    keycloak.init((instance) => {
        Vue.prototype.$keycloak = instance

        new Vue({
            router,
            clickoutside,
            i18n,
            render: h => h(App),
        }).$mount('#app')
    })
})
